import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';

import { useGetFirstInteractionChartQuery } from '../../../../app/services/chatbot-rtk.services';
import LoadingComponent from '../../../common/loading/loading.component';

interface ChartProps {
  from: string;
  to: string;
  botId: string;
}

const FirstIntractionChart: React.FC<ChartProps> = ({ from, to, botId }) => {
  const { t, i18n } = useTranslation();
  const [count, setCount] = useState<number>(0);
  const { data, error, isLoading, refetch, isFetching } = useGetFirstInteractionChartQuery({
    from,
    to,
    botId,
  });

  useEffect(() => {
    refetch();
  }, [from, to]);

  const [chartData, setChartData] = useState<any>(null);

  function calculateAverage(numbers?: number[]) {
    if (!numbers) {
      return 0;
    }
    if (numbers.length === 0) {
      return 0; // Handle empty array case
    }

    const sum = numbers.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    return sum / numbers.length;
  }

  useEffect(() => {
    setCount(0);
    setChartData(null);

    if (data) {
      const avg = calculateAverage(data.map((dr: any) => Number(dr.average))).toFixed(1);

      setCount(Number(avg));

      setChartData({
        labels: data.map((dr: any) => dr.date),
        datasets: [
          {
            label: '',
            data: data.map((dr: any) => Number(dr.average).toFixed(0)),
            backgroundColor: ['#312ee3'],
            borderColor: ['#312ee3'],
            borderWidth: 1,
          },
        ],
      });
    }
  }, [data, isFetching]);

  const config = {
    type: 'bar',
    data: chartData,
    options: {
      scales: {
        y: {
          beginAtZero: true,
        },
      },
    },
  };

  if (isLoading) return <LoadingComponent />;
  return (
    <div className="tw-flex tw-flex-col">
      <div className="tw-text-gray-800 tw-text-base tw-font-semibold tw-font-['Lexend'] tw-uppercase">{t('Charts/FirstInteraction/title')}</div>

      {count !== 0 ? (
        <div className="tw-text-gray-800 tw-text-3xl tw-font-medium tw-font-['Lexend']">
          {t('Charts/FirstInteraction/unitBefore') + ' ' + count + t('Charts/FirstInteraction/unitAfter')}
        </div>
      ) : (
        <div className="tw-text-gray-400 tw-text-xl tw-font-medium tw-font-['Lexend']">{t('Charts/NoData')}</div>
      )}
      <div className="tw-text-gray-800 tw-text-base tw-font-normal tw-font-['Lexend']">{`${count !== 0 ? t('Charts/FirstInteraction/description') : ''}`}</div>
      <div>{chartData && count !== 0 && <Bar data={config.data} options={config.options} />}</div>
    </div>
  );
};

export default FirstIntractionChart;
